import { render } from "./AddEditFormBlock.vue?vue&type=template&id=fc03a084"
import script from "./AddEditFormBlock.vue?vue&type=script&lang=js"
export * from "./AddEditFormBlock.vue?vue&type=script&lang=js"

import "./AddEditFormBlock.vue?vue&type=style&index=0&id=fc03a084&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__